import axios from "./axios";
import { handleApiError } from "./handleApiError";

export interface AdminLogItem {
  id: string;
  occurredAtUtc: string;
  actorUserId?: string;
  actorName?: string;
  actorRole?: string;
  actorIp?: string;
  area: string;
  action: string;
  severity: number;
  targetType?: string;
  targetId?: string;
  metadataJson?: string;
  statusCode?: number;
  correlationId: string;
}

export interface AdminLogResponse {
  total: number;
  items: AdminLogItem[];
}

export interface AdminLogQuery {
  startUtc?: string;
  endUtc?: string;
  area?: string;
  action?: string;
  actorUserId?: string;
  severity?: number;
  search?: string;
  page?: number;
  pageSize?: number;
}

export async function getAdminLogs(params: AdminLogQuery): Promise<AdminLogResponse> {
  try {
    const res = await axios.get("/admin/logs", { params });
    return {
      total: Number(res.data?.total ?? 0),
      items: Array.isArray(res.data?.items) ? (res.data.items as AdminLogItem[]) : [],
    };
  } catch (error) {
    return handleApiError(error, "getAdminLogs", { total: 0, items: [] });
  }
}

export async function exportAdminLogs(params: AdminLogQuery & { exportLimit?: number }): Promise<Blob | null> {
  try {
    const res = await axios.get("/admin/logs/export", {
      params,
      responseType: "blob",
    });
    return res.data as Blob;
  } catch (error) {
    return handleApiError(error, "exportAdminLogs", null);
  }
}

export async function purgeAdminLogs(params?: { olderThanDays?: number }): Promise<number | null> {
  try {
    const res = await axios.delete("/admin/logs/purge", { params });
    return Number(res.data?.deleted ?? 0);
  } catch (error) {
    return handleApiError(error, "purgeAdminLogs", null);
  }
}
